<template>
  <el-row :gutter="10">
    <el-col :span="6">
      <left-table />
    </el-col>
    <el-col :span="18">
      <right-table />
    </el-col>
  </el-row>
</template>
<script>
import LeftTable from './components/left-table/index.vue'
import RightTable from './components/right-table/index.vue'
export default {
  name: 'resourceManagement-researchInputTemplate',
  components: {
    LeftTable,
    RightTable,
  },
}
</script>

<!--<template>
  <div class="card-form">
    <div>
      <page-header
        @loadCategoryData="loadCategoryData"
        @reset="reset"
        @add="add"
        @delRows="delRows"
        slot="header"
        @submit="handleSubmit"
        ref="header"
      />
    </div>
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      :category-table-data="categoryTableData"
      :categoryLoading="categoryLoading"
      @submit="reload"
      @categoryClick="categoryClick"
    />
    <js-pagination
      class="mt-2"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      size="sm"
      align="right"
      @change="handlePaginationChange"
    />
  </div>
</template>

<script>
export default {
  name: 'resourceManagement-researchInputTemplate',
  components: {
    PageHeader: () => import('./components/header'),
    PageMain: () => import('./components/main')
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      },
      categoryLoading: false,
      categoryTableData: []
    }
  },
  methods: {
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      }
      this.$nextTick(() => {
        this.$refs.main.clearSelected()
      })
    },
    add() {
      this.$refs.main.fromLoad('add')
    },
    delRows() {
      this.$refs.main.delRows()
    },
    //加载分类数据
    loadCategoryData() {
      this.categoryLoading = true
      this.$api.masterCategory().then((res) => {
        this.categoryTableData = res.body.data
        this.categoryLoading = false
      })
    },
    // 点击分类触发事件
    categoryClick(val) {
      this.page = {
        curPage: 1,
        pageSize: 10,
        pageTotal: 0
      }
      this.$refs.header.assign(val)
      this.handleSubmit(val)
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 重载表格数据
    reload() {
      this.$refs.header.onReset()
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .listResearchInputTemplateApi({
          ...form,
          ...this.page
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>-->
